<template>
    <div>
        <div class="likes-overview" v-if="likes && likes.length > 0">
            <span class="likes-overview__text">
                <router-link :to="{ name: 'view-user', params: { user_id: likes[0].id } }">
                    {{ likes[0].id === user.id ? "You" : likes[0].name }}
                </router-link>
                <template v-if="likes.length > 1">
                    and <a href="#" @click.prevent.stop="$modal.show(`other-likes-${sectorPost}`)">{{ likes.length - 1 }} {{ likes.length - 1 > 1 ? "others" : "other" }}</a>
                </template>
                liked this
            </span>
            <div class="likes-overview__avatars">
                <img
                    v-for="user in likes.slice(0, 3)"
                    :src="user.avatar ? user.avatar.url : '//placehold.it/32x32'"
                    :alt="`Profile Image for ${user.name}`"
                />
            </div>
        </div>
        <modal :name="`other-likes-${sectorPost}`">
            <h2>Users who liked this</h2>
            <ul class="other-likes-list">
                <li v-for="user in likes">
                    <UserCard
                        :user="user"
                        :borderless="true"
                        :small="true"
                    />
                </li>
            </ul>
        </modal>
    </div>
</template>
<script>
import SearchModalForm from '@components/SearchModal/Form.vue';
import UserCard from '@components/User/UserCard.vue';
import { mapState } from 'vuex';

export default {
    name: 'LikesOverview',
    components: {
        UserCard,
        SearchModalForm
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
    },
    props: {
        sectorPost: {
          type: Number,
          required: true,
        },
        likes: {
            type: Array,
            default : null
        }
    },
    methods: {
        handleOpen() {
            this.$modal.show("other-likes");
            // this.$modal.hide("related-item-search");
        }
    }
}

</script>
<style scoped lang="scss">
@import '~@/theme/_variables.scss';
.likes-overview {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: 1rem;

    .likes-overview__text {
        font-family: Axiforma, sans-serif;
        font-size: 1.2rem;
        line-height: 1.4rem;
        color: $text;

        span, a {
            color: $link;
            font-weight: 600;
        }
    }

    .likes-overview__avatars {
        display: flex;
        flex-direction: row;
        align-items: center;

        img {
            border-radius: 50%;
            height: 3rem;
            width: 3rem;
            position: relative;

            &:nth-child(1){
                z-index: 3;
            }

            &:nth-child(2){
                z-index: 2;
            }

            &:nth-child(3){
                z-index: 1;
            }

            + img {
                margin-left: -1.5rem;

            }
        }
    }
}

.other-likes-list {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    margin: 0 -2rem;
    padding: 0 2rem 1rem;
    overflow-y: scroll;
    list-style: none;
    max-height: 23.4rem;
}
</style>
